export default __webpack_public_path__ + "static/media/logo-zest-branco.2c2e3f9d.svg";